import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import JobBoardCard from 'modules/ats/pages/JobPostingPromotion/JobBoards/JobBoardCard'
import integrationCodes from 'modules/marketplace/lib/integrationCodes'

import Logo from './wttj-logo.svg'

export const WelcomeToTheJungle = observer(() => {
  const { navigation } = useNavigation()

  const action = (
    <Button.Router
      to={navigation.discover.marketplace.item.fullPath({
        id: integrationCodes.welcome_to_the_jungle,
      })}
      rel="nofollow noopener noreferrer"
      type="secondary"
      iconName="external link"
      blankTarget
    >
      {i18n.t('ats.job_details.promotion.job_boards.buttons.promote_button')}
    </Button.Router>
  )

  return (
    <JobBoardCard
      title="Welcome to the Jungle"
      description={i18n.t('ats.job_details.promotion.welcome_to_the_jungle.description')}
      logo={Logo}
      action={action}
    />
  )
})
